import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { InsightsExpensesFeesContainerV2 } from 'packages/statements/ui/InsightsExpensesFeesContainerV2';

export const InsightsExpensesFeesRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights expenses & fees page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <InsightsTemplate selectedTab={TAB_OPTION_KEYS.expensesFees}>
          <InsightsExpensesFeesContainerV2 />
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
